import { render, staticRenderFns } from "./PalletsEs.vue?vue&type=template&id=6bb50c21&scoped=true&"
import script from "./PalletsEs.vue?vue&type=script&lang=js&"
export * from "./PalletsEs.vue?vue&type=script&lang=js&"
import style0 from "./PalletsEs.vue?vue&type=style&index=0&id=6bb50c21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb50c21",
  null
  
)

export default component.exports